// extracted by mini-css-extract-plugin
module.exports = {"col":"header-module--col--1R797","link":"header-module--link--3k-9z","title":"header-module--title--33m8q"};